import React from 'react'
import Loader from './Loader'

const Msg = () => {
  return (
    <div>
        <Loader/>

        <h1>Empty Cart</h1>
    </div>
  )
}

export default Msg